import Super from 'client-portal/routes/-request/message';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestMessage extends Super {}
